import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
	TRANSPARENT_COLOR,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame17 = (props: TQrFrameProps) => {
	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : FRAME_BLACK
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: TRANSPARENT_COLOR

	const getTextY = (fontSize: number) => {
		const boxTop = 66
		const boxHeight = 10
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				id="frame-background"
				width={64}
				height={84}
				rx={4}
				fill={frameBackgroundColor}
			/>
			<g id="frame" fill={frameColor}>
				<path d="M59.78 10.864H64l-.04 1.122h-3.54c.1.2.18.421.26.662a.568.568 0 1 1-1.08.36 4.8 4.8 0 0 0-.66-1.362l-.005-.007c-1.075-1.417-1.166-1.537-8.015-1.537H48.9a.76.76 0 0 0 0 1.523.581.581 0 0 1 0 1.163.76.76 0 0 0 0 1.524.581.581 0 0 1 0 1.162.76.76 0 0 0-.76.762c0 .36.24.661.58.741h.2c.32 0 .58.26.58.582q0 .12-.06.24c-.1.22-.3.36-.54.36-.1 0-.2 0-.3-.02H44c-.36 0-.74.281-.74.762 0 .482.3.822.74.822h7.56c1 0 1.74.26 2.2.742.36.4.54.922.5 1.523a24 24 0 0 1-.086 1.306l-.034.418c-.08.962-.14 1.724-.06 2.225.08.38.2.5.54.561.54.08.8-.4 1.36-2.065l.085-.25c.178-.521.377-1.105.635-1.674.26-.56.718-.8 1.137-1.02l.003-.002c.4-.2.78-.42 1.12-.882.72-.982 1.02-2.666 1.02-2.686a.57.57 0 0 1 .66-.46c.3.04.52.34.46.66 0 .04-.14.782-.44 1.624H64v1.163h-3.86c-.046.124-.117.224-.183.318q-.03.041-.057.083c-.5.701-1.08 1.002-1.52 1.222-.34.18-.52.281-.6.461-.24.531-.42 1.062-.592 1.568l-.088.256-.1.28c-.235.665-.441 1.247-.74 1.705-.38.58-.88.881-1.48.881-.1 0-.22 0-.32-.02-.82-.12-1.32-.62-1.48-1.483-.12-.641-.06-1.483.04-2.525.04-.501.08-1.083.12-1.684 0-.3-.06-.5-.2-.661-.24-.26-.7-.381-1.36-.381H44c-1.08 0-1.9-.842-1.9-1.964 0-1.063.86-1.925 1.9-1.925h3.14a2.2 2.2 0 0 1-.14-.741c0-.521.22-1.002.56-1.343-.34-.34-.56-.822-.56-1.343s.22-1.002.56-1.343c-.34-.34-.56-.822-.56-1.343C47 9.862 47.86 9 48.92 9h2.02c3.72 0 5.46.04 6.58.28 1.22.281 1.68.822 2.26 1.584M8.9 51.813c0 .32.26.581.58.581s.56-.26.56-.56v-31.37c0-.42.26-.762.6-.762h27.72a.581.581 0 0 0 0-1.162h-27.7c-.98 0-1.76.862-1.76 1.904zM25.64 64.84h27.7c.98 0 1.76-.862 1.76-1.904V31.568a.581.581 0 1 0-1.16 0v31.348c0 .42-.26.761-.6.761h-27.7a.581.581 0 0 0 0 1.163" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20 62.174h-7.58c-.66 0-1.12-.12-1.36-.38-.14-.161-.2-.361-.2-.662.04-.601.08-1.183.12-1.684.1-1.042.16-1.884.04-2.525-.16-.862-.66-1.363-1.48-1.483-.74-.12-1.36.18-1.8.861-.299.458-.505 1.04-.74 1.704l-.1.28-.088.257a17 17 0 0 1-.592 1.568c-.08.18-.26.28-.6.46-.44.221-1.02.522-1.52 1.223l-.049.073a3 3 0 0 0-.191.308H0v1.163h3.34c-.3.841-.44 1.583-.44 1.623a.57.57 0 1 0 1.12.2c0-.02.3-1.703 1.02-2.685.34-.461.72-.682 1.12-.882l.003-.002c.419-.22.878-.46 1.137-1.02.258-.57.457-1.153.635-1.675l.085-.25c.56-1.663.82-2.144 1.36-2.064.34.06.46.18.54.561.08.501.02 1.263-.06 2.225q-.023.295-.052.61c-.03.346-.063.715-.088 1.114-.04.601.14 1.122.5 1.523.46.481 1.2.742 2.2.742H20c.44 0 .74.34.74.822 0 .48-.38.761-.74.761h-4.6c-.1-.02-.2-.02-.3-.02h-4.22a1.923 1.923 0 0 0-.96 3.588c-.2.3-.3.661-.3 1.042 0 .662.34 1.243.84 1.584-.22.32-.34.701-.34 1.102 0 .26.06.521.16.762-4.086-.06-4.299-.34-5.191-1.512l-.009-.012a4.8 4.8 0 0 1-.66-1.363.568.568 0 1 0-1.08.36c.08.242.16.442.26.663H0v1.162h4.22c.56.762 1.04 1.303 2.26 1.583 1 .221 2.5.281 5.46.281h3.14c1.06 0 1.92-.862 1.92-1.924 0-.521-.22-1.002-.56-1.343.34-.34.56-.822.56-1.343s-.22-1.002-.56-1.343c.34-.34.56-.822.56-1.343 0-.26-.06-.52-.14-.741H20c1.04 0 1.9-.862 1.9-1.925 0-1.182-.82-2.024-1.9-2.024m-4.14 7.316a.76.76 0 0 1-.76.762h-3.58a.76.76 0 0 1 0-1.524h3.56c.44 0 .78.341.78.762m-.78 3.468H12c-.4-.02-.74-.361-.74-.762a.76.76 0 0 1 .76-.762h3.08a.76.76 0 1 1-.02 1.523m.78-6.154a.76.76 0 0 1-.76.762h-4.24a.76.76 0 0 1 0-1.523h4.04c.06.02.1.02.16.02h.2c.36.08.6.38.6.741"
				/>
			</g>
			<rect
				id="qr-background"
				x={14.5}
				y="24"
				width="35"
				height="35"
				rx="2"
				fill={qrBackgroundColor}
			/>
			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 20,
							y: 29.5,
							width: 24,
							height: 24,
						}),
					}}
				/>
			) : (
				<MockQr x={20} y={29.5} width={24} height={24} />
			)}
			<FrameText
				text={props.text}
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				xOffset={5}
				fontFamily={DEFAULT_FRAME_FONT}
			/>
		</svg>
	)
}
